export default __webpack_public_path__ + "static/media/trampapo_01-12.c270c90b.jpg";